module.exports = __webpack_public_path__ + "static/media/covidPin.03d09526.png";